export const testimonials = [
  {
    name: 'Mark Reynolds',
    role: 'Automotive Electronics Technician',
    location: 'Phoenix, AZ',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b4890fc8-9330-40ed-b7b9-082f20d05e6a.jpg',
    quote:
      "The Identification Blueprint alone changed how I start every job. I used to open five tabs before touching the module. Now I fill in the profile first and I know exactly what's missing.",
  },
  {
    name: 'Darnell Brooks',
    role: 'Diagnostic Specialist',
    location: 'Atlanta, GA',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/52319407-d93d-4ee2-83e4-d60b5b3b7c47.jpg',
    quote:
      "I keep the decision maps open on my phone at the bench. When a TCM won't communicate, I follow the route instead of guessing. It keeps me from jumping straight to 'the module is bad'.",
  },
  {
    name: 'Rachel Turner',
    role: 'Transmission & Electronics Tech',
    location: 'Columbus, OH',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6cae480-c333-4874-8bba-a090f6ce2b02.jpg',
    quote:
      'The Tool Selection Matrix saved me from buying another programmer I didn’t need. I checked the requirements against what I already owned, and the answer was right there.',
  },
  {
    name: 'Graham Whitfield',
    role: 'Independent Shop Owner',
    location: 'Leeds, UK',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c5015e39-69b5-4673-9a1f-6638c6d8744a.jpg',
    quote:
      'We printed the workbench checklists and the intake forms for the whole shop. Every TCM job is now documented the same way, and handovers between techs are far cleaner.',
  },
]
